














// @ts-nocheck
// ^^^^^^^^^^^ Disabled TypeScript linter in this file because it doesn't understand Vue components
// which is not wrapped in Vue.extend(), and we can't use Vue.extend() in Sanity serializers
// because of how src/components/SanityBlockContent.vue initializes the serializers.

export default {
  name: 'SanityQuoteSerializer',
  components: {
  },
  data() {
    return {};
  },
  props: {
    phrase: String,
    source: String,
  },
};
